export const mainStoreIdChanged = (storeId: string) => {
  return {
    type: 'MAIN_STORE_ID_CHANGED',
    payload: storeId,
  }
}
